import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import axios from '../../utils/axios';
import { primaryRestGateway } from '../../utils/apiEndpointUtility';

import {
	postBrowserDetails,
	postBrowserDetailsCompleted,
	postBrowserDetailsFailed,
	postNewMembershipSignup,
	postNewMembershipSignupCompleted,
	postNewMembershipSignupFailed,
	postCheckoutInitial,
	postCheckoutInitialCompleted,
	postCheckoutInitialFailed
} from './customerDetailsSlice';

export const postBrowserDetailsEpic = (action$) =>
	action$.pipe(
		ofType(postBrowserDetails),
		mergeMap(async (action) => {
			const payload = action.payload;

			const response = await axios.post(
				`${primaryRestGateway()}/api/v2/campaign`,
				payload
			);

			return response.data;
		}),
		switchMap((response) => [postBrowserDetailsCompleted(response)]),
		catchError((error, source) =>
			merge(of(postBrowserDetailsFailed(error.message)), source)
		)
	);

export const postNewMembershipSignupEpic = (action$) =>
	action$.pipe(
		ofType(postNewMembershipSignup),
		mergeMap(async (action) => {
			const payload = action.payload;

			const response = await axios.post(
				`${primaryRestGateway()}/api/v2/signup`,
				payload
			);

			return response.data;
		}),
		switchMap((response) => [postNewMembershipSignupCompleted(response)]),
		catchError((error, source) =>
			merge(of(postNewMembershipSignupFailed(error.message)), source)
		)
	);

export const postCheckoutInitialEpic = (action$) =>
	action$.pipe(
		ofType(postCheckoutInitial),
		mergeMap(async (action) => {
			const payload = action.payload;

			const response = await axios.post(
				`${primaryRestGateway()}/api/v2/checkout`,
				payload
			);

			return response.data;
		}),
		switchMap((response) => [postCheckoutInitialCompleted(response)]),
		catchError((error, source) =>
			merge(of(postCheckoutInitialFailed(error.message)), source)
		)
	);

export default [
	postBrowserDetailsEpic,
	postNewMembershipSignupEpic,
	postCheckoutInitialEpic
];
